import { httpClient } from '@bcba/client-auth';

const basePath = '/documents';

export const getUrlFileFromAws = async (uuid: string) => {
  const { data } = await httpClient.get<string>(`${basePath}/${uuid}`);

  return data;
};
